// extracted by mini-css-extract-plugin
module.exports = {"event-join-page":"JoinPage_event-join-page__1iFah","spinner-icon":"JoinPage_spinner-icon__2y-hN","error-message":"JoinPage_error-message__3wlC0"};